module.exports = __webpack_public_path__ + "img/member_cards_icon.066a2d10.png";